@import '../../../global/styles/focus.scss';
@import '../../../global/styles/media-queries.scss';

:host {
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 8px 4px 0 24px;
    position: relative;

    .world {
        background: none;
        outline: none;
        border: none;
        cursor: pointer;
        height: 40px;
        display: inline-block;
        margin-bottom: 4px;
        padding: 0;

        &:hover {
            --icon-color: #0076b2;
        }
    }

    .world:focus-within .world-icon {
        @include on-focus;
    }

    .dropdown {
        position: absolute;
        background-color: rgb(241, 241, 241);
        box-shadow: rgba(0, 0, 0, 0.25) 0px 0px 8px 0px;
        color: black;
        top: 100%;
        overflow: hidden;
        height: auto;
        font-family: var(--csb-font-family-roboto);
        font-weight: 100;
        font-size: 16px;
        font-weight: 400;
        line-height: 16px;
        color: black;
        opacity: 0;
        transform-origin: top;
        transform: translateY(-29px);
        transition: opacity 300ms ease, transform 600ms ease;
        pointer-events: none;
        visibility: hidden;

        &.open {
            transform: translateY(-3px);
            opacity: 1;
            pointer-events: auto;
            visibility: visible;
        }

        ul {
            margin-top: 10px;
            list-style: none;
            text-decoration: none;
            display: flex;
            flex-direction: column;
            gap: 24px;
            padding: 20px 40px;

            li {
                a {
                    cursor: pointer;

                    &:hover {
                        color: #0076b2;
                        border-bottom: 1.5px solid #0076b2;
                    }

                    &:focus-visible {
                        @include on-focus;
                    }
                }

                a.selected {
                    font-weight: 700;
                    color: black;
                    border-bottom: 1.5px solid black;
                }

                a.selected:hover {
                    border-bottom: 1.5px solid #0076b2;
                    color: #0076b2;
                }
            }
        }
    }

    @include on-tablet-big {
        margin: 0;

        .dropdown {
            opacity: 0;
            transition: opacity,transform 0.3s ease;
            overflow: hidden;
            top: auto;
            top: 0;
            bottom: unset;
            width: 100vw;
            left: -24px;
            background-color: rgba(29, 32, 33, 0.7);
            box-shadow: none;
            z-index: 10;
            align-items: end;

            ul {
                left: 0;
                height: 0;
                position: absolute;
                transition: height 0.5s ease-in-out;
                right: 0;
                margin-bottom: 0;
                bottom: 0;
                background-color: white;
            }

            &.open {
                transform: translateY(-100%);
                opacity: 1;

                ul {
                    height: 375px;
                }

                height: calc(100vh - 78px);
            }
        }
    }
}

:host(.black) {
    --icon-color: black;
}

:host(.white) {
    --icon-color: white;
}